// extracted by mini-css-extract-plugin
export default {"container":"CustomRedirect_container__WlacI","content":"CustomRedirect_content__jGCSX","heading":"CustomRedirect_heading__1u7ql","text":"CustomRedirect_text__rV+HF"};